"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaConfigOpcoesMatricula = exports.yupConfigOpcoesMatricula = void 0;
const yup = __importStar(require("yup"));
exports.yupConfigOpcoesMatricula = yup.object({
    dias_atraso_rematricula: yup
        .number()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Bloquear clientes em atraso'),
    bloqueio_por_produto: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Bloquear clientes com o produto em aberto'),
    rematric_dataini: yup
        .date()
        .required()
        .default(new Date(new Date().getFullYear(), 0, 1))
        .label('Inicio da rematrícula'),
    rematric_datafim: yup
        .date()
        .required()
        .when('rematric_dataini', (rematric_dataini, schema) => rematric_dataini && schema.min(rematric_dataini))
        .default(new Date(new Date().getFullYear(), 11, 31, 23, 59, 59))
        .label('Fim da rematrícula'),
    rematric_financeiro: yup
        .boolean()
        .required()
        .default(false)
        .label('Apresentar a guia finalizar na tela de rematricula'),
    rematric_mae_valida: yup.boolean().required().default(false).label('Validar campos obrigatórios da mãe'),
    rematric_pai_valida: yup.boolean().required().default(false).label('Validar campos obrigatórios do pai'),
    rematric_limpar_enderecos: yup.boolean().required().default(false).label('Limpar Endereços'),
    rematric_habilitar_turno: yup.boolean().required().default(false).label('Permitir que o usuário escolha o turno'),
    rematric_valida_certidao_nascimento_novo: yup
        .boolean()
        .required()
        .default(false)
        .label('Validar Certidão de Nascimento Modelo Novo'),
    rematric_enviar_email: yup.boolean().required().default(false).label('Enviar e-mail ao aceitar o contrato'),
    rematric_fiador: yup.boolean().required().default(false).label('Apresentar a guia do Fiador'),
    rematric_pessoas_autorizadas: yup
        .boolean()
        .required()
        .default(false)
        .label('Apresentar a guia de pessoas autorizadas e transporte escolar'),
    bloqueio_aceite_rematricula: yup
        .number()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Bloqueio sem aceite de contrato'),
    rematric_msgdevedor: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Mensagem para alunos com saldo devedor'),
    rematric_msgbloqueio: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Mensagem para alunos bloqueados no sistema'),
    mensagem_rematricula: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Mensagem de após matrícula / rematrícula'),
    mensagem_email: yup.string().notRequired().nullable().default(undefined).label('Corpo do e-mail do contrato'),
});
exports.schemaConfigOpcoesMatricula = exports.yupConfigOpcoesMatricula.shape({});
